import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSocketConnection } from '../socket';
import { useOperationalStatus } from '../hooks';
const defaultOptions = {
    enabled: true,
};
export const useChannel = (name, options) => {
    const { enabled } = { ...defaultOptions, ...options };
    const socket = useSocketConnection();
    const [operationalStatus] = useOperationalStatus();
    const [state, setState] = useState();
    const channel = useMemo(() => {
        if (!socket || !enabled || operationalStatus !== 'normal') {
            return;
        }
        return socket.channel(name);
    }, [socket, name, enabled, operationalStatus]);
    useEffect(() => {
        channel?.join().receive('ok', () => {
            setState('joined');
        });
        channel?.onClose(() => {
            setState('closed');
        });
        return () => {
            if (channel?.state === 'joined') {
                setState('closed');
                channel.leave();
            }
        };
    }, [channel]);
    const on = useCallback((name, callback) => {
        const handle = channel?.on(name.toString(), callback);
        return () => {
            if (!handle) {
                return;
            }
            channel?.off(name.toString(), handle);
        };
    }, [channel]);
    return useMemo(() => ({
        isJoined: state === 'joined',
        on,
    }), [state, on]);
};
//# sourceMappingURL=useChannel.js.map